import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { fetchData } from '@/services/fetchData';
import { SettingsType } from '@/types';
import { TemplatePageContent } from '@/components/TemplatePageContent';

const Restaurant = ({
  content,
  menu,
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  return (
    <TemplatePageContent
      common={menu.translations.common}
      content={content}
      menu={menu}
    />
  );
};

export async function getServerSideProps({
  params,
  resolvedUrl,
  locale,
}: GetServerSidePropsContext) {
  const paramsId = params?.restaurant;

  const content = await fetchData({
    url: `/content/trade/${paramsId}/view`,
    locale,
  });

  const menu: SettingsType = await fetchData({
    url: `/settings/view`,
    locale,
  });

  const isError = !content || content.code !== 200;

  if (isError) return { notFound: true };

  if (!resolvedUrl.includes(content.item.type)) return { notFound: true };

  return {
    props: {
      content,
      menu,
    },
  };
}

export default Restaurant;
